import type { ValueOf } from 'type-fest';

export const StockStatus = {
  IN_STOCK: 'inStock',
  SOLD_OUT: 'soldOut',
  PRE_ORDER: 'preorder',
  SUPPLIER_STOCK: 'supplierStock',
} as const;

export type StockStatusT = ValueOf<typeof StockStatus>;

const isStockStatus = (current: StockStatusT, target: StockStatusT): boolean => current === target;

export const getStockStatusChecks = (status: StockStatusT) => ({
  isInStock: isStockStatus(status, StockStatus.IN_STOCK),
  isSoldOut: isStockStatus(status, StockStatus.SOLD_OUT),
  isPreOrder: isStockStatus(status, StockStatus.PRE_ORDER),
  isSupplierStock: isStockStatus(status, StockStatus.SUPPLIER_STOCK),
});
